<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between headline">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              <new-envelope-dialog class="ml-2" v-if="canCreateEnvelope" @doneNewEnvelope='handleDoneNewEnvelope'></new-envelope-dialog>
              <v-btn class="ml-2" small color="white black--text" @click="new_payment_type = 'cash'"><v-icon left>mdi-cash-multiple</v-icon>Receber Dinheiro</v-btn>
              <v-btn class="ml-2" small color="white black--text" @click="new_payment_type = 'check'"><v-icon left>mdi-checkbook</v-icon>Receber Cheque</v-btn>
            </div>
            <div>
              <span>Envelopes</span>
              <v-btn text icon color="white" aria-label="Atualizar lista" @click="onHeaderRefreshEnvelopes">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text class="py-0 px-0">
            <router-view></router-view>
          </v-card-text>
    
        </v-card>
      </template>
    </index-card>

    <NewPayment
      v-if="new_payment_type"
      :key="new_payment_type"
      kind="envelope"
      :envelope_type="new_payment_type"
      @done="onHeaderRefreshEnvelopes"
      @close="new_payment_type = null"
    ></NewPayment>
  </div>
</template>

<script>
export default {
  name: 'Envelopes',
  provide() {
    const vm = this
    return {
      registerEnvelopesListReload(fn) {
        vm.envelopesListReload = fn
      },
    }
  },
  data() {
    return {
      envelopesListReload: null,
      new_payment_type: null,
    }
  },
  components: {
    NewEnvelopeDialog: () => import('@/_backoffice/_financial/components/envelope/shared/NewEnvelopeDialog.vue'),
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
  computed:{
    canCreateEnvelope(){
      return this.has_roles(['Manager', 'Director', 'Analyst', 'SalesExecutive']) 
    },
  },
  methods: {
    handleDoneNewEnvelope(e){
      this.$emit('doneNewEnvelope', e)
    },
    onHeaderRefreshEnvelopes() {
      if (this.envelopesListReload) this.envelopesListReload()
    },
  },
}
</script>
